import Moment from 'moment-timezone';
import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import MathJax from '../component/react-mathjax-preview';
import { Button, DialogContainer, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import '../css/mediaCss.css';
import styles from '../css/styles.css.js';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { AppProperties } from '../common/function';

let ansText, questionMap;

// class EmptyToolbar extends React.Component {
// 	componentDidMount() {
// 		this.props.onToggleFilter()
// 	}
	
// 	render() {
// 		return (<div></div>)
// 	}
// }
export default class TestScore extends Component {
  appProperties = AppProperties();
  constructor(props) {
    super(props);
    this.state = {
      quiz_scores: [],
      visible: false,
      class_name: this.props.location.query.class,
      quiz_name: this.props.location.query.qname,
      static: this.props.location.query.static,
      quiz_id: this.props.location.query.quiz_id,
      is_anonymous: this.props.location.query.is_anonymous,
      quizData:[],
      answersMap: {},
      questionHash: {},
      questions: [],
      exportData: [],
      questionMap:[],
      loading:true,
      value: 0,
      noDataFlag:false,
      question_headers:[],
      answerContent:'',
      headers:[],
      gradeBookHeight:-1,
      filterInt: {},
      filterData: [],
      searchInputBox: ""
    };
    this.processTestScoreData = this.processTestScoreData.bind(this)
    this.handleAddFilter = this.handleAddFilter.bind(this)
    this.handleClearFilters = this.handleClearFilters.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.getFilteredRows = this.getFilteredRows.bind(this)
    this.selectors = Data.Selectors;
  } 

  contentStore = (answerText) => {
    this.setState({visible:true, answerContent:answerText})
  }
  
   displayRPAnswers = (answerText) => {
  return <div style={{textAlign:'center'}}>
           {answerText.length > 10 ? <Button style={{height:'50px'}} raised onClick = {()=>this.contentStore(answerText)}>View Answer</Button> : answerText} 
          </div>;
  }

  updateProgressBarValue = (len) => {
    return new Promise((resolve, reject)=>{

      try {
        if(this.state.value < 80) {
          this.setState(prevState => {
            return {
              value : prevState.value + ((1/len)*80)
            }
          }, ()=>{
            console.log("Call from updateProgressBarValue", this.state.value)
            resolve(true)
          })
        }else{
          resolve(false)
        }
      }catch(err){
          console.log("Error - updateProgressBarValue", err)
          reject(err)
      }
    })
  }

  processTestScoreData = async (data) =>{

    let isQuizEmpty = false;     
    if (data !== undefined && data !== null &&
      data.quiz_scores !== null && data.quiz_scores !== undefined) {
      let full_score_if_attempted = data.full_score_if_attempted
      var tempdataArr = [];
      var exportDataArr = [];
      var resp_questions = data.questions;
      var resp_question_map =  data.questions_map;
      var resp_answers =  data.answers_map

       /* Questions header */
       let question_headers = [];

       let tempAnswerKeys = [];
       if(resp_question_map && Object.keys(resp_question_map).length && resp_answers && Object.keys(resp_answers).length){
         for(let[q_key,q_value] of Object.entries(resp_question_map)) {
           for(let[a_key,a_value] of Object.entries(resp_answers)){
             if(a_key.includes(q_key)){
     
             let tempAnswer = a_value.text ? a_value.text.replace(/<[^>]+>/g,'') : '';
             //   console.log('TempAnser', a_value.text)
               tempAnswerKeys.push(a_key)
               question_headers.push({key: a_key, label:`${q_value.category_name} - ${q_value.subcategory_name} - ${q_value.text} - ${tempAnswer}`})
             }
           }
         }
       }

       
      for(var  i = 0; i < data.quiz_scores.length; i++){
      // tempdata[i] =  data.quiz_scores[i];
      //bug id 175
      //await this.updateProgressBarValue(data.quiz_scores.length);
      var tempdata = data.quiz_scores[i];
      var exportData = data.quiz_scores[i];
      let nonGradedQuestionCount = 0
      if(data.quiz_scores[i] && data.quiz_scores[i].non_graded_count){
        nonGradedQuestionCount =data.quiz_scores[i].non_graded_count
      }

      let totalQuestionsInQuiz = data.totalQuestionsInQuiz !== undefined && data.totalQuestionsInQuiz !== null ? data.totalQuestionsInQuiz : 0

      let correct_answers_count = 0;
      if(resp_questions && resp_questions.length === nonGradedQuestionCount) {
        for (const [key, value] of Object.entries(tempdata.student_answers)) {
          if(value.AnsId && value.AnsId !== null && value.AnsId.length > 0) {
            if(data.questions_map[key] && data.questions_map[key] !== null 
              && data.questions_map[key].correct_answers && data.questions_map[key].correct_answers.length > 0) {
                let tmp_corr_ans = data.questions_map[key].correct_answers[0].split("_"), 
                    corr_ans = tmp_corr_ans[tmp_corr_ans.length - 1];
                if(Number(corr_ans) === Number(value.AnsId[0])) {
                  correct_answers_count += Number(tempdata['ques_corr']) > 0 ? tempdata['ques_corr'] : 1;
                  value.QScore = 1;
                } else {
                  value.QScore = 0;
                }
                tempdata.student_answers[key] = value;
            }
          }
        }
      }

     //complete percentage
      tempdata['gradebook_score'] =  tempdata['total_score'] 

      if(tempdata["isScoreChanged"] === 1)  {
        tempdata['gradebook_score'] = tempdata['editedScore']
      }


      //calculate test score %
      if(data.quiz_scores[i]['total_question'] === nonGradedQuestionCount) {
        tempdata['ques_corr'] =  correct_answers_count;
        tempdata['total_score'] =  Math.round((data.quiz_scores[i]['ques_corr']/((nonGradedQuestionCount) || 1))*100);
      } else {
        tempdata['ques_corr'] =  data.quiz_scores[i]['ques_corr'];
        tempdata['total_score'] =  Math.round((data.quiz_scores[i]['ques_corr']/((data.quiz_scores[i]['total_question']-nonGradedQuestionCount) || 1))*100) ;
      }

      if (tempdata && tempdata['total_score'] > 100) {
        tempdata['total_score'] = 100
      }

      tempdata['quiz_time'] = data.quiz_scores[i]['quiz_time'];


          
          let QMap ={};

          let newQuestionMap = resp_questions.map((data)=>{

              if(data.split("_").length === 6){
                  let Arr = data.split("_");
                  let lastDigit = Arr.pop();
                  let QID = Arr.join("_");
                  if(!QMap.hasOwnProperty(QID)){
                    QMap[QID]=[];
                  }
                  QMap[QID].push(lastDigit);
                  return data;
              }
              return 0;
          });

          let newfixedData = newQuestionMap.map((data)=>{

            if(data !== 0){
                let Arr = data.split("_");
                let lastDigit = Arr.pop();
                let QID = Arr.join("_");
                if(QMap[QID].includes('0')){
                    lastDigit=parseInt(lastDigit)+1;
                    let result = Arr.join("_");
                    result=`${result}_${lastDigit}`;
                    return result;
                }else{
                    return data;
                }
            }
            return 0;
        });

         let finalQuestionMapData = newfixedData.map((data, index)=>{

          if(data === 0){
              return resp_questions[index];
          }else{
              return data;
          }
        });

      questionMap = finalQuestionMapData.map((row) => this.rowIDFixforMQT(row));

          for(let  j = 0; j < questionMap.length; j++){

            let row = questionMap[j];

            if(exportData.student_answers !== undefined && exportData.student_answers !== null){
              exportData["score" + j] = (exportData.student_answers[questionMap[j]] !== undefined && exportData.student_answers[questionMap[j]] !== null?
                exportData.student_answers[questionMap[j]].QScore === -1?'n/a':exportData.student_answers[questionMap[j]].QScore:0);
                exportData["ans_choice" +j ] = exportData.student_answers[row] !== undefined && exportData.student_answers[row] !== null ?
                (exportData.student_answers[row].AnswerText !== "" ?
                // exportData.student_answers[row].AnswerText.replace(/~/g,' ').replace(/"/g, '""')
                (() => {
                  const rawText = exportData.student_answers[row].AnswerText;
                  const match = rawText.match(/^(\d+)_/);
                  const processedText = match ? match[1] : rawText;
                  return processedText.replace(/~/g,' ').replace(/"/g, '""');
                })()
                 :
                  (exportData.student_answers[row].AnsId !== undefined && exportData.student_answers[row].AnsId !== null ?
                    (exportData.student_answers[row].AnsId.map((r,x) =>(
  
                      data.answers_map[row + "_" + r] !== undefined && data.answers_map[row + "_" + r] !== null ?
                      data.answers_map[row + "_" + r].order+ " " :" "
  
                      ))
                    ) :
                    ""
                  )
                )
                :"";
                exportData["elapsed_time" + j] = (exportData.questions_elapsed_time[this.rowIDFixforElapsedTime(resp_questions[j])] !== undefined && 
                  exportData.questions_elapsed_time[this.rowIDFixforElapsedTime(resp_questions[j])] !== null ?
                  exportData.questions_elapsed_time[this.rowIDFixforElapsedTime(resp_questions[j])].elapsed_time:"");
            }
            
            if(exportData.student_answers !== undefined && exportData.student_answers !== null && exportData.student_answers[questionMap[j]] !== undefined && exportData.student_answers[questionMap[j]] !== null && exportData.student_answers[questionMap[j]] && exportData.student_answers[questionMap[j]].CorrectAnswerText && exportData.student_answers[questionMap[j]].CorrectAnswerText.length>0){
              let rawText = exportData.student_answers[questionMap[j]].CorrectAnswerText.replace(/~/g,' ');
              if (rawText && rawText.includes("_")) {
                let arr = rawText.split("_")
                if (arr && arr.length) {
                  rawText = arr[0];
                }
              }
              exportData["correct_ans" + j] = rawText;
            }
            else{
              exportData["correct_ans" + j] =   data.questions_map !== undefined && data.questions_map !== null ?
                    (data.questions_map[resp_questions[j]] !== null ?
                      (data.questions_map[resp_questions[j]].correct_answers?
                        (data.questions_map[resp_questions[j]].correct_answers.map((r,k) => (
                          data.answers_map && data.answers_map[r] ?
                          data.answers_map[r].order+ " "
                          :r

                          ))
                        )
                        : " "
                      )
                      :
                      " "
                    ):" "
              }
          }

        /* Fetch student answered checkbox id by id asc order*/
        let final_data = {};

        let temp_question_ids = [...questionMap];
        let Student_answered_id = []
         temp_question_ids && temp_question_ids.map((data) => {
           if(exportData.student_answers !== undefined && exportData.student_answers !== null && Object.keys(exportData.student_answers).length){
             for(let[q_key, q_value] of Object.entries(exportData.student_answers)){
                  if(data ===  q_key){
                    q_value && q_value.AnsId && q_value.AnsId.map((ans_id) => {
                      Student_answered_id.push(`${q_key}_${ans_id}`)
                    });
                  }
             }
          }
        });
        
        /* Assing 0 and 1 for answered and non ansered check boxes */

        final_data['answerStatus'] = {};
        final_data['answerAscOrderStatus'] = [];
          tempAnswerKeys.length && tempAnswerKeys.map((header_key) => {
              if((Student_answered_id && Student_answered_id .length && Student_answered_id.some(key => key === header_key))){
                  final_data['answerAscOrderStatus'].push(1);
                  final_data['answerStatus'][header_key] = 1;
              }else{
                  final_data['answerAscOrderStatus'].push(0);
                  final_data['answerStatus'][header_key] = 0;
              }
          })
          exportData = {...exportData, ...final_data.answerStatus}
          tempdata = {...tempdata, ...final_data}
          
          tempdataArr.push(tempdata);
          exportDataArr.push(exportData);
    }


    let headers = [
      { label: 'First Name', key: 'first_name', width: 150, sortable: true},
      { label: 'Last Name', key: 'last_name', width: 150, sortable: true },
      { label: 'Student ID', key: 'OSUID' , width: 250, sortable: true, filterable: true},
      { label: 'SF ID', key: 'userID', width: 150, sortable: true },
      { label: 'Practice Count', key: 'practice_count', width: 150, sortable: true },
      { label: 'Section Name', key: 'section_name' , width: 150},
      { label: 'Subsection Name', key: 'subsection_name' , width: 150},
      { label: 'Test Name', key: 'quiz_name', width: 150 },
      { label: 'Score %', key: 'total_score' , width: 150, sortable: true},
      { label: 'Gradebook Score', key: 'gradebook_score', width: 150, sortable: true },
      { label: 'Questions Correct', key: 'ques_corr' , width: 150, sortable: true}, 
      { label: 'Start Date', key: 'startDate' , width: 250, sortable: true},
      { label: 'Completion Date', key: 'completedDate' , width: 250, sortable: true},       
      { label: 'AssignmentTime(sec)', key: 'time_elapsed' , width: 100, sortable: true}
    ];

    if (this.state.is_anonymous && JSON.parse(this.state.is_anonymous)) {
      headers = headers.filter(header => !['first_name', 'last_name'].includes(header.key))
      headers = headers.map(header =>{
        if (header.key === 'OSUID') {
          return {
            ...header,
            label: 'Anon - ID'
          };
        }
          return header;
      })

      exportDataArr = exportDataArr.map((data, index) => {
        return {
          ...data,
          OSUID: `Student ${index+1}`
        }
      })
    }

    let scoreArr = [];
    let ansChoice = [];
    let corAnswer = [];
    let elapsedTime = [];

    data.questions.map((rowData, index) => {
      let baseText = data.questions_map[rowData].text;
      baseText = baseText.replace(/<[^>]*>/g, '');
      scoreArr.push({ label:baseText + "(score)", key: "score"+index});
      ansChoice.push({ label:baseText + "(answer choice)", key: "ans_choice"+index});
      corAnswer.push({ label:baseText + "(correct answer)", key: "correct_ans"+index});
      elapsedTime.push({ label:baseText + "(elapsed time)", key: "elapsed_time"+index});
    })

    headers = [...headers, ...scoreArr, ...ansChoice, ...corAnswer, ...elapsedTime];

    question_headers.map((rowData) => (
      headers.push({ label: rowData.label, key:`${rowData.key}` })
    ))

    headers = headers.map(header => {
      return {
        ...header,
        label: header.label.replace(/"/g, '""')
      }
    })

      console.debug("headers>>>>", headers, exportDataArr)

      this.setState({
        quizData : tempdataArr,
        exportData: exportDataArr,
        filterData: exportDataArr,
        // questions: data.questions,
        // answersMap: data.answers_map,
        // questionHash: data.questions_map,
        // questionMap : questionMap,
        // question_headers: question_headers,
        headers: headers
      });
    }else{
      isQuizEmpty = true;
    }
    this.setState({loading:false,noDataFlag:isQuizEmpty})
    window.scrollTo(0,0)
  }

  //Code to Get Archive Data
  getTestViewScoreArchiveData = async(semesterID,courseID,sectionID,quizID)=> {
        
    try{
        let getQuizViewScoreDataResp = await ApiRequestService({
            method: 'post',
            url:'archivedQuizViewScore',
            data: { semesterID:semesterID,
                courseID:courseID,
                sectionID:sectionID,
            quizID:quizID}
        })
        if(getQuizViewScoreDataResp.data !== undefined && getQuizViewScoreDataResp.data !== null){
            if(getQuizViewScoreDataResp.data.status === 0 && getQuizViewScoreDataResp.data.data !== undefined && getQuizViewScoreDataResp.data.data !== null){
                
              this.processTestScoreData(JSON.parse(getQuizViewScoreDataResp.data.data));

            }else if (getQuizViewScoreDataResp.data.message !== undefined &&  getQuizViewScoreDataResp.data.message !== null ) {
                NotificationManager.error(getQuizViewScoreDataResp.data.message,"Error",5000);
            }else{
                NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
            }
        }else{
            NotificationManager.error("Archive failed with Unknown Server Error","Error",5000);
        }
    }catch(err){
       
        NotificationManager.error(err,"Error",5000);
    }finally{
        this.setState({loadingCourse:false});
    }
}
  componentDidMount() {

      if(this.props.location.query.archiveMode){
        let semesterID = parseInt(this.props.location.query.semesterID,10);
        let courseID = parseInt(this.props.location.query.courseID,10);
        let sectionID = parseInt(this.props.location.query.sectionID,10);
        let quizID = parseInt(this.props.location.query.quizID,10);
        this.getTestViewScoreArchiveData(semesterID,courseID,sectionID,quizID);
      }else{

        
        const payload = {
          quiz_name: this.state.quiz_name,
          class_name: this.state.class_name,
          static: 1, //parseInt(this.state.static, 10)
          quiz_id:parseInt(this.state.quiz_id, 10)
        };
        console.debug('Quiz Score req : ', payload);




        ApiRequestService({
          method: 'post',
          //url: '/getQuizScore',
          url: '/getTestScore',
          data: payload
        }).then(res => {
          if(res && res.data && res.data.data){
                this.processTestScoreData(res.data.data);
          }
        });
      }
  }

  componentWillUpdate() {
    this.addBreadCrumbs();
  }
  componentWillUnmount() {
    this.removeBreadCrumbs();
  }
  addBreadCrumbs = () => {
    this.props.replaceBreadCrumb([
      { 
        name: this.props.location.query.course_name, 
        type: '', 
        onclickPath: 'CoursesDashboard?course_indx=' + this.props.location.query.course_indx
      }
    ]);
  };
  removeBreadCrumbs = () => {
    this.props.replaceBreadCrumb([]); 
  };

  
  rowIDFixforMQT = (row) =>{
    let myArr = row.split("_")
    if(myArr.length===6){
      myArr[5]=parseInt(myArr[5])-1;
      let result = myArr.join("_");
      return result;
    }
    return row;
  }

  rowIDFixforElapsedTime = (row) =>{
    let myArr = row.split("_")
    if(myArr.length===6){
      myArr.pop();
      let result = myArr.join("_");
      return result;
    }
    return row;
  }

  // Handle updating filters
  handleFilterChange = filter => filters => {
    const newFilters = { ...filters };
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    return newFilters;
  };

  getFilteredRows = (r, f) => {
    return this.selectors.getRows({ rows: r, filters: f });
  };

  handleAddFilter = filter => {
    this.setState((prevState)=>({ 
      filterData: this.getFilteredRows(prevState.filterData, this.handleFilterChange(filter)),
      filterInt: this.handleFilterChange(filter)
    }))
  };

  handleClearFilters = () => this.setState({filterInt: {}});

  calculateGradebookHeight = () => {
    let delta = 200;
    let dropDownCell = document.getElementById('courseDropboxCell');
    if (dropDownCell !== undefined &&  dropDownCell !== null){
        delta = dropDownCell.offsetHeight + 32 + 60 + 5;
    }
    return  window.innerHeight - delta;
  }

  rowGetter = (i) => {
    if(this.state.filterData.length > 0 ){
       return this.state.filterData[i];
    }
    return null;
  };

  hanleTextChange = (value) => {
    this.setState({searchInputBox: value}, () => {
      const filteredData = this.state.exportData.filter((el) => {
        //if no input the return the original
        if (value.trim() === '') {
          return el;
        }
        //return the item which contains the user input
        else {
          return el.OSUID.toLowerCase().includes(value.trim())
        }
      })
      this.setState({filterData: filteredData});
    });
  }

  handleSetRows = (sortColumn, sortDirection) => {
    let initialRows = this.state.exportData
    const comparer = (a, b) => {
        if (sortDirection === "ASC") {
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
        } else if (sortDirection === "DESC") {
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
        }
    };
    let temp = sortDirection === "NONE" ? initialRows : [...initialRows].sort(comparer);

    this.setState({
      exportData:temp
    })
  }


  render() {
    
     let {gradeBookHeight} = this.state;
     if(gradeBookHeight === -1 ){
         gradeBookHeight = this.calculateGradebookHeight();
     } 
    let downloadCSV = (
      <Button raised disabled>
        Download CSV
      </Button>
    );

    if (this.state.quizData.length > 0) {
      let currentTime = Moment.tz(Date(), this.appProperties.currentUserData.timeZone || "America/New_York");
      downloadCSV = (
        <div>
          <CSVLink
            id="csv-download-link"
            data={this.state.exportData}
            headers={this.state.headers}
            filename={
              this.props.location.query.qname +
            '_' +
            this.props.location.query.course_name +
            '_' +
            currentTime.format()+
            '.csv'
            }
          >
            {
              <Button primary swapTheming raised className="buttonColour">
                Download CSV
              </Button>
            }
          </CSVLink>
        </div>
      );
    }
    return (
      (this.state.loading) ?
      //<CircularProgressBar value = {this.state.value} />
      <LoadingSpinner loading={this.state.loading} />
     :
      <div>
        <div className="row" style={{ paddingLeft: '40px' }}>
          <span style={{ float: 'left', padding: '10px' }}>
            <h1>Test Results - {this.state.quiz_name}</h1>
          </span>
        </div>
        <div className="row">
          <span
            style={{ float: 'right', display: 'flex', marginRight: '30px' }}
          >
            
            <span>{downloadCSV}</span>
          </span>
        </div>
        <br/>
        <div style={{width:'20%', float:'right', marginTop:'10px'}}>
        <TextField
          value={this.state.searchInputBox}
          label="Search"
          id={`search-by-username`}
          type="text"
          onChange={(value) => this.hanleTextChange(value)}
          helpText="Filter by Student ID"
        />
        </div>
        <div style={{marginLeft:'10px'}}>
        { this.state.headers.length > 0 &&  
        <ReactDataGrid
          ref="grid"
          columns={(this.state.headers).map(c => ({ width:100, ...c, name:c.label, resizable: true}))}
          className="fill-grid"
          rowGetter={this.rowGetter}
          minHeight={gradeBookHeight}
          rowsCount={this.state.filterData.length}
          onGridSort={(sortColumn, sortDirection) =>
            this.handleSetRows(sortColumn, sortDirection)
           }
          //  toolbar={<EmptyToolbar/>}
          //  onAddFilter  = {this.handleAddFilter}
          //  onClearFilters = {this.handleClearFilters}
           sortColumn= {"last_name"}
           sortDirection= {'ASC'}
        />}
        </div>
        <DialogContainer width="auto"  id="textualRPAnswer" visible={this.state.visible}>
         {<div dangerouslySetInnerHTML={{__html: this.state.answerContent}}></div>}
        <center><Button flat primary swapTheming onClick={()=>this.setState({visible:false})} >Close</Button></center>
        </DialogContainer>
      </div>
    );
  }
}
